import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { WOOSMAP_LOADER, WOOSMAP_KEY } from '~/const/3rd';

var StoreAvailabilityModal = function StoreAvailabilityModal() {
  return import(
  /* webpackMode: "eager" */
  '~/components/molecules/Product/Modal/StoreAvailabilityModal.vue');
};

export default {
  name: 'StoreAvailability',
  components: {
    StoreAvailabilityModal: StoreAvailabilityModal
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    isSimpleLink: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showModal: false,
      modal: null,
      loaded: false
    };
  },
  methods: {
    closeAction: function closeAction() {
      this.showModal = false;
      this.modal = null;
    },
    handleClick: function handleClick(event) {
      var _this = this;

      if (!this.loaded) {
        this.asyncScript(WOOSMAP_LOADER).then(
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee() {
          var loaderOptions;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  loaderOptions = {
                    version: '1.4',
                    publicKey: WOOSMAP_KEY
                  };
                  window.WoosmapLoader.load(loaderOptions);
                  _this.loaded = true;

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))).catch(function (err) {
          console.error(err);
        });
      }

      this.modal = 'store-availability-modal';
      this.showModal = true;
      this.$root.$emit('generic-tracking', event, {
        fn: 'track-event',
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_Dispo_mag',
          event_label: "".concat(window.tc_vars.page_cat1, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      });
    }
  }
};